export const DATAFLOW_TYPE_NORMAL = 'DATAFLOW_TYPE_NORMAL';
export const DATAFLOW_TYPE_VIRTUAL = 'DATAFLOW_TYPE_VIRTUAL';
export const DATAFLOW_TYPE_ONLY_FILE = 'DATAFLOW_TYPE_ONLY_FILE';